module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "vulcan--dataset-cover.c0dd17be.jpg";